/**
 * @generated SignedSource<<c5620198eaefc91fb646e55e36360073>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type appStateAdminUserQuery$variables = Record<PropertyKey, never>;
export type appStateAdminUserQuery$data = {
  readonly isAdminUser: boolean;
  readonly seller: {
    readonly sellerID: number;
  } | null;
};
export type appStateAdminUserQuery = {
  response: appStateAdminUserQuery$data;
  variables: appStateAdminUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAdminUser",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellerID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "appStateAdminUserQuery",
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Seller",
        "kind": "LinkedField",
        "name": "seller",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "appStateAdminUserQuery",
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Seller",
        "kind": "LinkedField",
        "name": "seller",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "993ee9d950ec628ce89240d8b5adf776",
    "id": null,
    "metadata": {},
    "name": "appStateAdminUserQuery",
    "operationKind": "query",
    "text": "query appStateAdminUserQuery {\n  isAdminUser\n  seller {\n    sellerID\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "cf6c3e9327b4c341432d581581eea381";

export default node;
